import { module } from 'modujs';
import { roundRandom, random} from '../utils/maths';
import { gsap } from 'gsap';
import { html } from '../utils/environment';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.mouse = {
            x: 0,
            y: 0
        };
        this.oldMouse = {
            x: 0,
            y: 0
        };

        this.delay = 15;

        this.$stickers = this.$('sticker');
        this.$stickerContainer = this.$('stickerContainer')[0];
        this.isMoving = false;

        this.maxTrailCount = window.isMobile ? 5 : 30;
        this.trail = new Array();

        this.iterator = 0;

        if(window.isMobile) {
            this.animate();
        } else {
            this.bindMousemove = this.mousemove.bind(this);
            window.addEventListener('mousemove', this.bindMousemove);
        }

    }

    mousemove(e) {
        this.isMoving = true;

        this.mouse.x = e.clientX;
        this.mouse.y = e.clientY;
        
        if(this.isMoving) {
            this.animate();
        }
        
    }

    animate() {
        this.iterator++;
        this.raf = requestAnimationFrame(() => this.animate());

        if(window.isMobile) {
            this.mouse.x = random(0, window.innerWidth);
            this.mouse.y = random(0, window.innerHeight);
        }

        if(html.classList.contains('has-dom-ready')) {
            
            if(window.isMobile) {
                if(this.iterator % this.delay == 0) {
                    let sticker = this.$stickers[roundRandom(0, this.$stickers.length - 1)].cloneNode(true);
                    this.$stickerContainer.appendChild(sticker);

                    if(window.scroll.scroll.instance.scroll.y == undefined) {
                        window.scroll.scroll.instance.scroll.y = 0;
                    }
            
                    sticker.style.top = `${this.mouse.y + random(-100, 100) + window.scroll.scroll.instance.scroll.y}px`;
                    sticker.style.left = `${this.mouse.x + random(-100, 100)}px`;
                
                    this.add(sticker);

                    if(this.trail.length > this.maxTrailCount) {
                        this.remove(this.trail[0]);
                    }

                    this.oldMouse.x = this.mouse.x;
                    this.oldMouse.y = this.mouse.y;
                }
            } else {
                if(this.oldMouse.x != this.mouse.x || this.oldMouse.y != this.mouse.y || window.isMobile) {
                    if(Math.abs(this.oldMouse.x - this.mouse.x) > 20 && Math.abs(this.oldMouse.y - this.mouse.y) > 20) {
                        
                        let sticker = this.$stickers[roundRandom(0, this.$stickers.length - 1)].cloneNode(true);
                        this.$stickerContainer.appendChild(sticker);
    
                        if(window.scroll.scroll.instance.scroll.y == undefined) {
                            window.scroll.scroll.instance.scroll.y = 0;
                        }
                
                        sticker.style.top = `${this.mouse.y + random(-100, 100) + window.scroll.scroll.instance.scroll.y}px`;
                        sticker.style.left = `${this.mouse.x + random(-100, 100)}px`;
                    
                        this.add(sticker);
    
                        if(this.trail.length > this.maxTrailCount) {
                            this.remove(this.trail[0]);
                        }
    
                        this.oldMouse.x = this.mouse.x;
                        this.oldMouse.y = this.mouse.y;
                    }
                }
            }
        }

    }

    add(sticker) {
        this.trail.push(sticker);

        gsap.fromTo(sticker,{
            scale: 0,
            x: '-50%',
            y: '-50%',
            rotation: `${random(-30,30)}deg`
        }, {
            scale: random(0.5, 1),
            rotation: `${random(-30,30)}deg`,
            duration: 0.4
        });        
    }

    remove(sticker) {

        this.trail.shift();

        gsap.to(sticker,{
            scale: 0,
            rotation: `${random(-30,30)}deg`,
            duration: 0.4,
            onComplete: () => {
                if(sticker !== undefined) {
                    sticker.remove();
                }
            }
        })
    }

    disable() {
        this.trail.forEach((sticker) => {

            gsap.to(sticker,{
                scale: 0,
                rotation: `${random(-30,30)}deg`,
                duration: 0.4,
                onComplete: () => {
                    if(sticker !== undefined) {
                        sticker.remove();
                    }
                }
            })
        })
    }

    destroy() {
        clearInterval(this.interval);
        window.removeEventListener('mousemove', this.bindMousemove);
        cancelAnimationFrame(this.raf);
        
    }
}
